import api from './client';

export const login = (email, password) =>
  api.post('/users/login', `username=${encodeURIComponent(email)}&password=${encodeURIComponent(password)}`, {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  });

export const logout = () => api.post('/users/logout');

export const getMe = () => api.get('/users/me');
